function transformToSections(input) {
  const sections = [];

  function flatten(obj, parentKey = '', result = []) {
    Object.entries(obj).forEach(([key, value]) => {
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        // Se é um objeto, verifica se tem propriedade 'text' (objeto simples)
        if (value.hasOwnProperty('text')) {
          // Objeto simples com propriedade 'text' - extrai apenas o valor text
          result.push({
            label: parentKey ? `${parentKey} >: ${key}` : key,
            value: value.text,
            needsAttention: value.needsAttention, // Preserva a propriedade needsAttention
          });
        } else {
          // Se é um objeto complexo, continua recursivamente
          const label = parentKey ? `${parentKey} >: ${key}` : key;
          flatten(value, label, result);
        }
      } else if (Array.isArray(value)) {
        // Se é um array, processa os itens
        if (value.length > 0 && typeof value[0] === 'object' && value[0].hasOwnProperty('text')) {
          // Array de objetos com propriedade 'text' - extrai apenas os valores text
          const processedValue = value.map(item => item.text).join(', ');
          // Verifica se todos os itens têm needsAttention = true
          const allNeedAttention = value.every(item => item.needsAttention === true);
          const allDontNeedAttention = value.every(item => item.needsAttention === false);

          result.push({
            label: parentKey ? `${parentKey} >: ${key}` : key,
            value: processedValue,
            needsAttention: allNeedAttention ? true : allDontNeedAttention ? false : null,
          });
        } else {
          // Array normal
          const processedValue = value.join(', ');
          result.push({
            label: parentKey ? `${parentKey} >: ${key}` : key,
            value: processedValue,
          });
        }
      } else {
        // Valor simples
        result.push({
          label: parentKey ? `${parentKey} >: ${key}` : key,
          value: String(value),
        });
      }
    });

    return result;
  }

  for (const [sectionTitle, sectionData] of Object.entries(input)) {
    const data = flatten(sectionData);
    sections.push({ title: sectionTitle, data });
  }

  return sections.filter(section => !['Conforto', 'Segurança'].includes(section.title));
}

function getEvaluationV2Photos(input) {
  const sections = transformToSections(input);

  const allPhotos = sections.map((section, key) => {
    const inPhotos = section.data.filter(item => item.label.includes('Foto'));

    const photos = inPhotos.map(photo => photo.value.split(','));

    return {
      group: section.title,
      photos: photos[0],
    };
  });

  return {
    items: allPhotos,
  };
}

function checkItemsToHaveDivider(arr, forceAllDividers = false) {
  const len = arr.length;

  if (len <= 1 && !forceAllDividers) {
    return arr.map(value => ({ value, useDivider: false }));
  }

  return arr.map((value, i) => {
    const position = i + 1;
    // Se forceAllDividers for true, todos os itens têm divider
    // Caso contrário, todos os itens exceto o último devem ter divider
    const useDivider = forceAllDividers || position < len;

    return { value, useDivider };
  });
}

export { transformToSections, getEvaluationV2Photos, checkItemsToHaveDivider };
